<template>
  <div class="paymentDelivery__summary__wrapper">
    <template v-if="this.isSummaryLoading">
      <section class="summary-skeleton placeholder-glow">
        <span class="placeholder sk-head"></span>

        <div class="paymentDelivery__summary__wrapper__section">
          <!-- řádek: celkem za zboží -->
          <div class="paymentDelivery__summary__wrapper__section__my-row">
            <span class="placeholder sk-left"></span>
            <span class="placeholder sk-right"></span>
          </div>

          <!-- blok: doprava -->
          <div class="paymentDelivery__summary__wrapper__section__my-row column line">
            <div class="my-row">
              <span class="placeholder sk-left"></span>
              <span class="placeholder sk-right"></span>
            </div>
            <div class="address"><span class="placeholder sk-address"></span></div>
          </div>

          <!-- blok: platba -->
          <div class="paymentDelivery__summary__wrapper__section__my-row column line">
            <div class="my-row">
              <span class="placeholder sk-left"></span>
              <span class="placeholder sk-right"></span>
            </div>
            <div class="address"><span class="placeholder sk-address"></span></div>
          </div>
        </div>

        <div class="paymentDelivery__summary__wrapper__section">
          <div class="paymentDelivery__summary__wrapper__section__my-row">
            <span class="placeholder sk-left"></span>
            <span class="placeholder sk-right sk-right--bold"></span>
          </div>
        </div>
      </section>
      <section
          v-if="$props.page == 'informace'"
          class="summary-skeleton summary-skeleton--bottom placeholder-glow"
      >
        <p>
          <span class="placeholder sk-paragraph"></span>
          <span class="placeholder sk-paragraph"></span>
          <span class="placeholder sk-paragraph sk-paragraph--short"></span>
        </p>

        <div class="btn-yellow submit-btn sk-btn" aria-hidden="true">
          <span class="placeholder sk-btn-text"></span>
        </div>
      </section>
    </template>
    <template v-else>
      <section>
        <span>Souhrn</span>

        <div class="paymentDelivery__summary__wrapper__section">
          <div
              class="paymentDelivery__summary__wrapper__section__my-row"
              v-if="cartPriceSummary"
          >
            <span>Celkem za zboží</span>
            <span>{{ cartPriceSummary }} Kč</span>
          </div>

          <!-- ✅ DOPRAVA: jen pokud je typ validní -->
          <div
              class="paymentDelivery__summary__wrapper__section__my-row column line"
              v-if="deliveryTypeResolved"
          >
            <div class="my-row">
              <span>Druh dopravy</span>
              <span>{{ deliveryTypeResolved.price }}</span>
            </div>
            <div class="address">{{ deliveryTypeResolved?.name }}</div>
            <div class="address">{{ deliveryTypeResolved?.address?.info }}</div>
          </div>

          <!-- ✅ PLATBA: jen pokud je typ validní -->
          <div
              class="paymentDelivery__summary__wrapper__section__my-row column line"
              v-if="paymentTypeResolved"
          >
            <div class="my-row">
              <span>Druh platby</span>
              <span>{{ paymentTypeResolved.price }}</span>
            </div>
            <div class="address">{{ paymentTypeResolved.name }}</div>
          </div>
        </div>

        <div
            class="paymentDelivery__summary__wrapper__section"
            v-if="cartSummaryPrice"
        >
          <div class="paymentDelivery__summary__wrapper__section__my-row">
            <span>Celkem za zboží</span>
            <span>{{ cartSummaryPrice }} Kč</span>
          </div>
        </div>
      </section>

      <section v-if="$props.page == 'informace'">
        <p>
          Kliknutím na tlačítko "odeslat objednávku" souhlasíte s obchodními
          podmínkami a ochranou osobních údajů.
        </p>

        <button
            v-on:click="triggerSubmit"
            class="btn-yellow submit-btn"
            :disabled="isSubmitting"
            type="button"
        >
          <template v-if="isSubmitting">
            <VaProgressCircle indeterminate size="small"/>
          </template>
          <template v-else>
            Odeslat objednávku
            <img src="../../../public/assets/icons/double_arrow_white.svg" alt=""/>
          </template>
        </button>
      </section>
    </template>
  </div>
</template>

<script>
import axios from "../../api";

export default {
  props: {
    page: String,
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      deliveryTypes: [],
      paymentTypes: [],
      isTypesLoading: false,
    };
  },

  computed: {
    paymentType() {
      return this.$store.state.paymentType;
    },
    deliveryType() {
      return this.$store.state.deliveryType;
    },

    // ✅ skeleton má běžet, dokud nejsou natažené listy (až pak umíme "resolved")
    isSummaryLoading() {
      return this.isTypesLoading || !this.deliveryTypes.length || !this.paymentTypes.length;
    },

    cartPriceSummary() {
      let price = 0;
      if (this.$store.state.cart) {
        this.$store.state.cart.forEach((element) => {
          price += element.price * element.count;
        });
      }
      return price;
    },

    // ✅ resolved = jen když existuje v aktuálním seznamu z API/cache
    deliveryTypeResolved() {
      const id = this.deliveryType?.id;
      if (!id || !this.deliveryTypes?.length) return null;
      return this.deliveryTypes.find((d) => d.id === id) || null;
    },
    paymentTypeResolved() {
      const id = this.paymentType?.id;
      if (!id || !this.paymentTypes?.length) return null;
      return this.paymentTypes.find((p) => p.id === id) || null;
    },

    cartSummaryPrice() {
      const pay = this.paymentTypeResolved?.priceNumber ?? 0;
      const del = this.deliveryTypeResolved?.priceNumber ?? 0;
      return pay + del + this.cartPriceSummary;
    },
  },

  methods: {
    // ✅ 1) načti listy (cache -> API)
    async loadTypesCached() {
      if (this.isTypesLoading) return;
      this.isTypesLoading = true;

      try {
        // delivery
        const cachedDelivery = this.$store.state.deliveryTypesCache;
        if (cachedDelivery && cachedDelivery.length) {
          this.deliveryTypes = cachedDelivery;
        } else {
          const response = await axios.get("/api/deliveryTypes");
          const mapped = response.data.map((item) => ({
            ...item,
            price: item.price == 0 ? "ZDARMA" : item.price + " Kč",
            priceNumber: item.price,
          }));
          this.deliveryTypes = mapped;
          this.$store.commit("setDeliveryTypesCache", mapped);
        }

        // payment
        const cachedPayment = this.$store.state.paymentTypesCache;
        if (cachedPayment && cachedPayment.length) {
          this.paymentTypes = cachedPayment;
        } else {
          const response = await axios.get("/api/paymentTypes");
          const mapped = response.data.map((item) => ({
            ...item,
            price: item.price == 0 ? "ZDARMA" : item.price + " Kč",
            priceNumber: item.price,
          }));
          this.paymentTypes = mapped;
          this.$store.commit("setPaymentTypesCache", mapped);
        }
      } finally {
        this.isTypesLoading = false;
      }
    },

    // ✅ 2) po načtení listů ověř localStorage/store (stejné jako initDefaults)
    initDefaultsFromLocalStorage() {
      const lsDelivery = JSON.parse(localStorage.getItem("deliveryType") || "null");
      const lsPayment = JSON.parse(localStorage.getItem("paymentType") || "null");

      const deliveryExists =
          lsDelivery?.id && this.deliveryTypes.some((d) => d.id === lsDelivery.id);
      const paymentExists =
          lsPayment?.id && this.paymentTypes.some((p) => p.id === lsPayment.id);

      if (deliveryExists) {
        this.$store.commit("updateDeliveryType", lsDelivery);
      } else {
        const defaultDelivery =
            this.deliveryTypes.find((d) => d.id === 1) || this.deliveryTypes[0];
        if (defaultDelivery) {
          this.$store.commit("updateDeliveryType", defaultDelivery);
          localStorage.setItem("deliveryType", JSON.stringify(defaultDelivery));
        }
      }

      if (paymentExists) {
        this.$store.commit("updatePaymentType", lsPayment);
      } else {
        const defaultPayment =
            this.paymentTypes.find((p) => p.id === 1) || this.paymentTypes[0];
        if (defaultPayment) {
          this.$store.commit("updatePaymentType", defaultPayment);
          localStorage.setItem("paymentType", JSON.stringify(defaultPayment));
        }
      }
    },

    triggerSubmit() {
      if (this.isSubmitting) return;
      this.$emit("submit-order");
    },
  },

  async mounted() {
    await this.loadTypesCached();
    this.initDefaultsFromLocalStorage();
  },
};
</script>

<style lang="scss">
/* =========================
   ✅ SKELETON STYLES
   (využívá bootstrap .placeholder pokud ho máš)
   ========================= */
.summary-skeleton {
  .sk-head {
    display: inline-block;
    height: 14px;
    width: 90px;
    border-radius: 10px;
    margin-bottom: 1rem;
  }

  .sk-left {
    display: inline-block;
    height: 14px;
    margin: 0.6rem 0;
    width: 140px;
    border-radius: 10px;
  }

  .sk-right {
    display: inline-block;
    height: 14px;
    margin: 0.6rem 0;
    width: 80px;
    border-radius: 10px;
  }

  .sk-right--bold {
    height: 16px;
    width: 90px;
  }

  .sk-address {
    display: inline-block;
    height: 12px;
    width: 190px;
    border-radius: 10px;
  }

  .sk-address--short {
    width: 150px;
  }

  &--bottom {
    margin-top: 0.5rem;

    .sk-paragraph {
      display: block;
      height: 10px;
      width: 100%;
      border-radius: 10px;
      margin: 0.6rem 0;
    }

    .sk-paragraph--short {
      width: 80%;
    }

    .sk-btn {
      width: 100%;
      margin-top: 1.5rem;
      border-radius: 2rem;
      min-height: 4.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .sk-btn-text {
      display: inline-block;
      height: 14px;
      width: 160px;
      border-radius: 10px;
    }
  }
}

/* nechávám tvůj původní CSS beze změny */
@media screen and (min-width: $screen-md-min) {
  .paymentDelivery__summary__wrapper {
    max-width: 34.5rem;
  }

  @media screen and (max-width: $screen-lg-min - 1px) {
    .paymentDelivery__summary__wrapper {
      section:last-child p {
        margin-bottom: auto;
      }
    }
  }
}

.paymentDelivery {
  &__summary {
    &__wrapper {
      background: $white;
      border-radius: 2rem;
      padding: 2.5rem;

      section {
        > span {
          padding-bottom: 1rem;
        }
      }

      > span:first-child {
        font-size: 1.2rem;
      }

      span {
        font-size: 1.4rem;
      }

      &__section {
        position: relative;

        &:nth-child(2) {
          border-bottom: 1px solid $gray;
        }

        &__my-row {
          padding: 0.8rem 0;
          display: flex;
          position: relative;
          justify-content: space-between;

          &.column {
            flex-direction: column;
          }

          .address {
            font-size: 12px;
            line-height: 18px;
            margin-bottom: 0.2rem;
          }

          .my-row {
            justify-content: space-between;
            width: 100%;
            display: flex;
          }

          &.line {
            &::after {
              content: "";
              height: 1px;
              width: 100%;
              position: absolute;
              top: 0;
              background-color: $gray-second;
            }
          }

          :last-child {
            font-weight: 400;
          }
        }

        &:nth-child(3) {
          div:first-child {
            span:first-child {
              font-size: 1.7rem;
              font-weight: 400;
            }

            span:last-child {
              font-size: 1.5rem;
              font-weight: 700;
            }
          }
        }
      }

      section:nth-child(2) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        p {
          font-size: 1.1rem;
          line-height: 1.3rem;
          margin-bottom: 3rem;
        }

        .btn-yellow {
          font-size: 1.4rem;
          width: 100%;
        }

        .submit-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          min-height: 4.2rem;
        }

        .submit-btn:disabled {
          opacity: 0.75;
          cursor: not-allowed;
        }
      }
    }
  }
}

@media screen and (min-width: $screen-lg-min) {
  .paymentDelivery {
    &__summary__wrapper {
      width: 100%;
      margin-left: auto;
    }
  }
}

@media screen and (max-width: $screen-md-min - 1px) {
  .paymentDelivery__summary__wrapper section:nth-child(2) {
    margin-top: 1.5rem;
  }
}
</style>
